"use client";
import "@/app/ui/WindTracker/global2.scss";
import { useParams } from "next/navigation";

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const { language } = useParams();
  return (
    <>
      <head>
        {language === "en-us" ? (
          <link
            href="https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap"
            rel="stylesheet"
          />
        ) : null}
        <link
          rel="stylesheet"
          href={
            language === "en-us"
              ? "https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@300;400;500;700&display=swap"
              : "https://fonts.googleapis.com/css2?family=Noto+Sans+HK:wght@300;400;500;700&display=swap"
          }
        ></link>
        {language === "en-us" ? (
          <link
            href="https://fonts.googleapis.com/css2?family=Red+Hat+Text:ital,wght@0,300..700;1,300..700&display=swap"
            rel="stylesheet"
          ></link>
        ) : null}
      </head>
      {children}
    </>
  );
}
